export const environment = {
  production: false,
  backend: 'http://localhost:8118',
};
